<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">
        <div class="col-12 mb-4">
            <v-card>
                <v-card-title>
                    {{$t('templates.management')}}
                    <v-spacer></v-spacer>
                    <v-text-field  v-model="search"  append-icon="mdi-magnify"  label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :items="templates"
                        :search="search"
                        sort-by="name"
                        class="elevation-1"
                        :loading="!templates" loading-text="Chargement en cours...">
                    <template v-slot:item._image="{item}">
                        <a v-if="item._image"
                        href="javascript:void(0)" @click="showImage('/'+item._image,item._name)" >
                            <v-img
                              style="cursor: pointer; margin: 2% "
                              :lazy-src="item._image"
                              max-height="50"
                              max-width="50"
                              :src="item._image" ></v-img>
                        </a>
                    </template>

                    <template v-slot:item._amount="{item}">
                        {{item._amount}} €
                    </template>

                    <template v-slot:item._access="{ item }">
                        <v-chip :color="item._access?'primary':'green'" dark>{{ item._access?"Gratuit":"Payant" }} </v-chip>
                    </template>

                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <v-spacer></v-spacer>
                                  <v-dialog v-model="dialogShowImg" max-width="90%">
                                      <v-card style="background: transparent !important;">
                                          <v-card-title>
                                              <span class="headline"> {{nametheme}} </span>
                                          </v-card-title>
                                          <v-card-text>
                                              <img :src="link" style="width: 100%; height: 100%" alt="">
                                          </v-card-text>
                                          <v-card-actions>
                                              <v-spacer></v-spacer>
                                              <v-btn class="dark" text @click="dialogShowImg = false">{{$t("close")}}</v-btn>
                                          </v-card-actions>
                                      </v-card>
                                  </v-dialog>



                            <v-dialog v-model="dialog" max-width="500px">
                                <template v-slot:activator="{ on }">
                                    <v-btn style="background: #29B3A6;color: #fff" class="mb-2" v-on="on">
                                        {{$t('templates.new')}}
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>


                                        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                            <v-alert v-if="errors" dense outlined
                                                     :type="(errors.update_error)?'error':'success'">
                                                {{$t(errors.message)}}
                                            </v-alert>

                                            <v-text-field v-if="submitting" color="primary" loading
                                                          disabled></v-text-field>

                                            <v-row>

                                                <v-col cols="12" sm="6" md="12">

                                                    <v-file-input
                                                            clearable="false"
                                                            id="input_file"
                                                            prepend-icon="mdi-camera"
                                                            v-model="editedItem._image" ref="file"
                                                            :rules="editedIndex === -1?imageRules:''" show-size
                                                            accept="image/*" label="Fichier"></v-file-input>
<!--
                                                    <span style="color: #B71C1C" v-if="errors_file!=null">{{errors_file}}</span>
-->
                                                </v-col>
                                                <v-col cols="12" sm="6" md="12">
                                                    <v-text-field :rules="nameRules" v-model="editedItem._name"
                                                                  :label="$t('templates.name')"></v-text-field>
                                                </v-col>


                                                <v-col cols="12" sm="6" md="12">
                                                    <v-row>
                                                        <v-col cols="4" sm="6" md="4">
                                                            <v-sheet width="100%" >
                                                                <v-switch style="background-color: #F8F8F8;"  v-model="editedItem._access" flat :label="editedItem._access?'Gratuit':'Payant'"></v-switch>
                                                            </v-sheet>

                                                        </v-col>
                                                        <v-col cols="8" sm="6" md="8" v-if="editedItem._access==false">
                                                            <v-text-field type="number" prepend-icon="€" :rules="editedItem._access==false?amountRules:''"
                                                                          v-model="editedItem._amount"
                                                                          :label="$t('templates.amount')"></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="dark"  @click="close">Annuler</v-btn>
                                        <v-btn color="primary" :disabled="!valid"  @click="save">Enrégistrer</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <div style="text-align:  right">
                          <v-menu
                                  key="text"
                                  rounded="b-xl">
                              <template v-slot:activator="{ attrs, on }">

                                      <v-icon

                                      class="black--text "
                                      v-bind="attrs"
                                      v-on="on">mdi-dots-vertical</v-icon>

                              </template>
                                <v-list>
                                    <v-list-item
                                            v-for="(action_item, index) in actions_items"
                                            :key="index"
                                            link
                                            @click="editItemAction(item,index)">
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6">{{action_item.avatar}}</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title v-text="action_item.title"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </template>
                    <template v-slot:no-data>
                        {{$t('no_data')}}
                    </template>
                </v-data-table>
            </v-card>
        </div>
    </div>

</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import CountryFlag from 'vue-country-flag'
    import helpers from "../../mixins/helpers";
    import countries from '../../resources/countries.json'
    import $ from 'jquery'

    export default {
        components: {
            CountryFlag
        },
        mixins: [helpers(this)],
        label: "Pays",
        data() {
            return {
                dialogShowImg: false,
                link:"",
                nametheme:'',
                submitting: false,
                valid: false,
                lazy: false,
                search: '',
                dialog: false,
                id: undefined,
                errors: undefined,
                editedOldImg: "",
                headers: [
                    {text: 'Image', value: '_image'},
                    {
                        text: 'Nom',
                        align: 'start',
                        sortable: true,
                        value: '_name',
                    },
                    {text: 'Référence', value: '_ref'},
                    {text: 'Accès', value: '_access'},
                    {text: 'Montant', value: '_amount'},
                    {text: '', value: 'actions', sortable: false},

                ],
                editedIndex: -1,
                editedItem: {
                    _name: '',
                    _amount: 0,
                    _ref: '',
                    _image: '',
                    _access: true,
                    _id: 0,
                    _created_at: 0,
                },
                defaultItem: {
                    _name: '',
                    _amount: 0,
                    _ref: '',
                    _image: '',
                    _access: true,
                    _id: 0,
                    _created_at: 0,
                },
                nameRules: [
                    v => !!v || 'Nom requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                imageRules: [
                    v => !!v || 'Image requise',
                ],
                amountRules: [
                    v => !!v || 'Montant requis',
                ],
                actions_items: [
                    {title: "Modifier", avatar: 'mdi-pencil'},
                    {title: "Supprimer", avatar: 'mdi-delete'}
                ],
            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? this.$t('templates.new') : this.$t('templates.update')
            },
            ...mapState('templates/', ['templates'])
        }
        ,
        mounted() {
            this.$vuetify.goTo(0)
            $(document).scrollTop()
            this.$store.dispatch('templates/getTemplates').then(response => {
            });
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            },
            showImage(img,name){
              this.link = img;
              this.nametheme = name;
              this.dialogShowImg = true;
            },
            editItemAction(item, index) {
                switch (index) {
                    case 0:
                        this.editItem(item)
                        break;
                    case 1:
                        this.deleteItem(item)
                        break;

                }
            },
            editItem(item) {
                this.editedIndex = this.templates.indexOf(item);

                this.editedItem = Object.assign({}, item);
                this.editedOldImg = item._image;

                this.dialog = true;
            }
            ,

            deleteItem(item) {
                const index = this.templates.indexOf(item);
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: this.$t('delete_warning'),
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Annuler",
                    showCancelButton: true,
                    cancelButtonColor: "#CCC",
                    confirmButtonColor: "#29B3A6"
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('templates/deleteTemplate', item._id).then((result) => {
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: this.$t(result.message),
                                position: 'top-end',
                                showConfirmButton: false
                            })
                        })
                    }
                })
            },
            save() {

                console.log("this.editedOldImg",this.editedOldImg);
                let VueBox = this;
                this.submitting = true;
                let data = new FormData();
                data.append("name", this.editedItem._name);
                data.append("access", this.editedItem._access);
                data.append("amount", (this.editedItem._access?0:this.editedItem._amount));
                data.append("file", this.editedItem._image);

                let mineroute = 'templates/setTemplate';
                if (this.editedIndex > -1) {
                    data.append("id", this.editedItem._id)
                    data.append("oldFile",this.editedOldImg);

                    mineroute = 'templates/updateTemplate';
                }
                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    VueBox.submitting = false;

                    if (response.data.error) {
                        VueBox.toast('error',response.data.message)
                    } else {

                        VueBox.toast('success',response.data.message)
                        VueBox.close();

                    }

                })
            },

            checkIfExist() {
                let VueBox = this;
                if (VueBox.editedIndex > -1) {
                    return VueBox.countries.find(value => value._code === VueBox.editedItem.code && value._id !== VueBox.editedItem._id)
                } else {
                    return VueBox.countries.find(value => value._code === VueBox.editedItem.code)
                }
            },
            getColor(calories) {
                if (calories > 230) return 'red'
                else if (calories > 200) return 'orange'
                else return 'green'
            },
            setCountryDetails() {
                let country = countries.find(country => country.iso2 == this.editedItem._code);
                this.editedItem._name = country.name;
                this.editedItem._code_iso_numerique = country.phone_code;
            },

        },

        created() {
            this.checkisDashboard();
            this.initialize()
        }
    }
</script>

<style scoped>

</style>
